import { render, staticRenderFns } from "./wyModalEditTPBehavioral.vue?vue&type=template&id=26b67389&"
import script from "./wyModalEditTPBehavioral.vue?vue&type=script&lang=js&"
export * from "./wyModalEditTPBehavioral.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditTPBehavioral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports